import React, { useEffect } from 'react';
import DepositModalSC, { DepositAlert } from './deposit-modal.styled';
import { HeadingTwo, SmallText, BodyText } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import { QRCode } from 'react-qrcode-logo';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import logo_symbol from '../../../assets/img/svg/wishmaker-logo-bg-white.png';

const DepositModal = ({
  depositModalData,
  userData,
  getDepositQrCodeString,
  resetDepositQrCodeString,
  codeString,
  codeStringError,
}) => {
  useEffect(() => {
    getDepositQrCodeString({
      data: {
        amount: depositModalData,
      },
    });

    return () => {
      resetDepositQrCodeString();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depositModalData]);

  return (
    <DepositModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage id="'Vklad_prostriedkov'" defaultMessage="Vklad prostriedkov" />
        </HeadingTwo>
      </div>
      <div className="price-wrap">
        <h2>{numeral(depositModalData).format('0,00.00')} €</h2>
      </div>

      <div className="deposit-summary-wrap modal-loading-wrap">
        <div className="deposit-summary-wrap--bottom__row columns">
          <div className="column vertical-align">
            <div className="d-block">
              <SmallText className="black-transparent block">
                <FormattedMessage
                  id="investor_invest_manage_deposit_modal_iban"
                  defaultMessage={dlt['investor_invest_manage_deposit_modal_iban']}
                />
              </SmallText>

              <BodyText className="bolder block">
                <FormattedMessage
                  id="investor_invest_manage_deposit_modal_iban_value"
                  defaultMessage={dlt['investor_invest_manage_deposit_modal_iban_value']}
                />
              </BodyText>
              <SmallText className="black-transparent block margin-top-15">
                <FormattedMessage
                  id="investor_invest_manage_deposit_modal_variable_symbol"
                  defaultMessage={dlt['investor_invest_manage_deposit_modal_variable_symbol']}
                />
              </SmallText>
              <BodyText className="bolder block">{userData.wm_number}</BodyText>
            </div>
          </div>
          <div className="column">
            <div className="d-block align-right">
              {codeStringError ? (
                <div className="qr-code-placeholder p5">
                  <FormattedHTMLMessage
                    id="onboarding_deposit_investor_qr_code_error"
                    defaultMessage={dlt['onboarding_deposit_investor_qr_code_error']}
                  />
                </div>
              ) : codeString ? (
                <QRCode logoWidth="35" logoImage={logo_symbol} value={codeString} />
              ) : (
                <div className="qr-code-placeholder">
                  <InlineLoading />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <DepositAlert
        type="warning"
        description={
          <FormattedHTMLMessage
            id="investor_invest_manage_deposit_modal_warning"
            defaultMessage={dlt['investor_invest_manage_deposit_modal_warning']}
            values={{
              firstname: userData.first_name,
              lastname: userData.last_name,
            }}
          />
        }
      />
    </DepositModalSC>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user,
    codeString: state.deposits.qrCodeString,
    codeStringError: state.deposits.qrCodeStringError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDepositQrCodeString: ActionCreators.getDepositQrCodeString,
      resetDepositQrCodeString: ActionCreators.resetDepositQrCodeString,
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DepositModal));
